//frontend/src/components/FlushMoonpigCardOrders.js
import React, { useState } from 'react';
import axios from 'axios';
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
    CircularProgress,
    Alert,
} from '@mui/material';
import Layout from './Layout';

const FlushMoonpigCardOrders = () => {
    const [refs, setRefs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [copied, setCopied] = useState(false);

    const fetchOrders = async () => {
        setLoading(true);
        setError('');
        setRefs([]);
        setCopied(false);
        try {
            const res = await axios.get('/api/manage-batches/moonpig-card-orders', { withCredentials: true });

            const data = res.data;
            if (data.success) {
                setRefs(data.externalRefs);
                if (data.externalRefs.length === 0) setError('No Moonpig card orders found.');
            } else {
                setError(data.message || 'Failed to fetch orders.');
            }
        } catch (err) {
            setError(err.message || 'Unknown error');
        } finally {
            setLoading(false);
        }
    };

    const handleCopy = () => {
        if (!refs.length) return;
        navigator.clipboard.writeText(refs.join('\n'));
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    return (
        <Layout>
            <Paper sx={{ maxWidth: 640, mx: 'auto', mt: 5, p: 3, borderRadius: 2, boxShadow: 4 }}>
                <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
                    Flush Moonpig Card Orders
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Shows only Moonpig <b>card</b> orders (excludes <i>No Card</i>). End of day: click to fetch and copy all External Ref numbers.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={fetchOrders}
                >
                    {loading ? <CircularProgress size={22} /> : 'Fetch List'}
                </Button>
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                {refs.length > 0 && (
                    <Box sx={{ mt: 3 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                            <Typography variant="subtitle2">
                                {refs.length} order(s): External Ref per row
                            </Typography>
                            <Button
                                variant="outlined"
                                color={copied ? "success" : "primary"}
                                onClick={handleCopy}
                                sx={{ minWidth: 130, ml: 2 }}
                            >
                                {copied ? "Copied!" : "Copy to Clipboard"}
                            </Button>
                        </Box>
                        <TextField
                            multiline
                            fullWidth
                            value={refs.join('\n')}
                            InputProps={{ readOnly: true }}
                            sx={{ mb: 1, fontFamily: 'monospace' }}
                            onFocus={e => e.target.select()}
                            maxRows={15}
                        />
                    </Box>
                )}

            </Paper>
        </Layout>
    );
};

export default FlushMoonpigCardOrders;
